import { useOutletContext } from 'react-router-dom';

/**
 * Shared report state handed down by `ReportsLayout`.
 *
 * Returns the URL-backed filter state (`filters`, `query`, `update`,
 * `applyPreset`, `reset`, `activePreset`) plus the caller's `activeRole`, so a
 * report page never has to rebuild any of it.
 */
export const useReportOutlet = () => useOutletContext();

export default useReportOutlet;
